/**
 * @generated SignedSource<<89cb51679b037bc5f6a791d3b9459ad0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedUrgencyLazy_buyerUrgencyInfo$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgency_buyerUrgencyInfo">;
  readonly " $fragmentType": "PdpSharedUrgencyLazy_buyerUrgencyInfo";
};
export type PdpSharedUrgencyLazy_buyerUrgencyInfo$key = {
  readonly " $data"?: PdpSharedUrgencyLazy_buyerUrgencyInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedUrgencyLazy_buyerUrgencyInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedUrgencyLazy_buyerUrgencyInfo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedUrgency_buyerUrgencyInfo"
    }
  ],
  "type": "BuyerUrgencyInfo",
  "abstractKey": null
};

(node as any).hash = "2284fbe29e8dd0153687bb2b9f243e3c";

export default node;
